import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import { useGetDetailRequests } from "../hooks";
import { Skeleton } from "antd";

export const ExportInformation: FC<{ eRequests: any }> = ({
  eRequests,
}: {
  eRequests: any;
}) => {
  const { data, isLoading } = useGetDetailRequests();
  if (isLoading) return <Skeleton />;

  return (
    <Box title="Thông tin chi tiết">
      <div className="list">
        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Họ và tên người yêu cầu</p>
            <strong>{data.createdBy.user.displayName}</strong>
          </div>
        </div>

        {/* {DETAIL.information.map((value) => {
          return (
            <div className="item">
              <div className="horizontal-content smColumn">
                <p className="w-100">{value.label}</p>
                <strong>
                  {data.fields?.[value.field] ||
                    JSON.parse(data.fields.eContent)[0][value.field]}
                </strong>
              </div>
            </div>
          );
        })} */}
      </div>
    </Box>
  );
};
